<template>
  <div class="works view" ref="view">
    <div class="view-content" ref="viewContent">
      <works-list v-if="worksLoaded" :data="works" :key="'works'"/>
    </div>
  </div>
</template>

<script>
import utils from "@/utils";
import { api, imageApi } from "@/api";

import WorksList from "@/components/WorksList";

export default {
  components: {
    WorksList
  },
  computed: {
    seoData() {
      return {
        title: "Works",
        description: "Check out my site projects!",
        template: "🦄 Antti Korhonen",
        url: `https://www.akworks.co${this.$route.path}`,
        image: imageApi.getUrl("https://www.akworks.co/img/share.png")
      };
    },
    works() {
      return this.$store.getters["works"];
    },
    worksLoaded() {
      return this.$store.getters["worksLoaded"];
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch("getWorks");
    });
  },
  beforeRouteLeave(to, from, next) {
    TweenMax.to(this.$refs.view, 0.3, {
      opacity: 0,
      ease: Cubic.easeInOut,
      onComplete: next
    });
  },
  mounted() {
    utils.setColor("#000000");
  },
  metaInfo() {
    return {
      title: this.seoData.title,
      titleTemplate: titleChunk =>
        titleChunk
          ? `${titleChunk} ${this.seoData.template}`
          : this.seoData.template,
      meta: [
        {
          name: "description",
          vmid: "description",
          content: this.seoData.description
        },
        {
          property: "og:title",
          vmid: "og:title",
          content: this.seoData.title,
          template: chunk => `${chunk} ${this.seoData.template}`
        },
        {
          property: "og:description",
          vmid: "og:description",
          content: this.seoData.description
        },
        {
          property: "og:type",
          vmid: "og:type",
          content: "article"
        },
        {
          property: "og:image",
          vmid: "og:image",
          content: this.seoData.image
        },
        {
          property: "og:url",
          vmid: "og:url",
          content: this.seoData.url
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
